import { render, staticRenderFns } from "./ylfw.vue?vue&type=template&id=688a99fb&scoped=true&"
import script from "./ylfw.vue?vue&type=script&lang=js&"
export * from "./ylfw.vue?vue&type=script&lang=js&"
import style0 from "./ylfw.vue?vue&type=style&index=0&id=688a99fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688a99fb",
  null
  
)

export default component.exports